var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核",
            visible: _vm.auditDialog,
            width: "60%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.auditDialog = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "log-container" }, [
            _vm.beforeUpdate.id
              ? _c(
                  "div",
                  { staticClass: "before-update" },
                  [
                    _c("h3", [_vm._v("修改前")]),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          model: _vm.beforeUpdate,
                          "label-width": "100px",
                        },
                        on: {
                          "update:model": function ($event) {
                            _vm.beforeUpdate = $event
                          },
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "rightsCode", label: "权益编号" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.beforeUpdate.rightsCode) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c("el-form-item", { attrs: { label: "权益名称" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.beforeUpdate.rightsName) +
                              "\n          "
                          ),
                        ]),
                        _c("el-form-item", { attrs: { label: "描述文案" } }, [
                          _vm.beforeUpdate.description
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.beforeUpdate.description)),
                              ])
                            : _c("span", [_vm._v("暂无描述")]),
                        ]),
                        _c("el-form-item", { attrs: { label: "客户端类型" } }, [
                          _c(
                            "div",
                            { staticStyle: {} },
                            _vm._l(
                              _vm.beforeUpdate.clientTypes,
                              function (item, index) {
                                return _c("span", { key: item }, [
                                  _vm._v(
                                    _vm._s(item) +
                                      _vm._s(
                                        index + 1 ===
                                          _vm.beforeUpdate.clientTypes.length
                                          ? ""
                                          : "，"
                                      )
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "限制参数" } },
                          _vm._l(
                            _vm.beforeUpdate.limitParams,
                            function (item, index) {
                              return _c("span", { key: item }, [
                                _vm._v(
                                  _vm._s(item) +
                                    _vm._s(
                                      index + 1 ===
                                        _vm.beforeUpdate.limitParams.length
                                        ? ""
                                        : "，"
                                    )
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                        _c("el-form-item", { attrs: { label: "类型状态" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.beforeUpdate.state) +
                              "\n          "
                          ),
                        ]),
                        _c("el-form-item", { attrs: { label: "备注" } }, [
                          _vm.beforeUpdate.remark
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.beforeUpdate.remark)),
                              ])
                            : _c("span", [_vm._v("暂无备注")]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "after-update" },
              [
                _c("h3", [_vm._v("修改后")]),
                _c(
                  "el-form",
                  {
                    attrs: { model: _vm.afterUpdate, "label-width": "100px" },
                    on: {
                      "update:model": function ($event) {
                        _vm.afterUpdate = $event
                      },
                    },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "权益编号" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.afterUpdate.rightsCode) +
                          "\n          "
                      ),
                    ]),
                    _c("el-form-item", { attrs: { label: "权益名称" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.afterUpdate.rightsName) +
                          "\n          "
                      ),
                    ]),
                    _c("el-form-item", { attrs: { label: "描述文案" } }, [
                      _vm.afterUpdate.description
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.afterUpdate.description)),
                          ])
                        : _c("span", [_vm._v("暂无描述")]),
                    ]),
                    _c("el-form-item", { attrs: { label: "客户端类型" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        _vm._l(
                          _vm.afterUpdate.clientTypes,
                          function (item, index) {
                            return _c("span", { key: item }, [
                              _vm._v(
                                _vm._s(item) +
                                  _vm._s(
                                    index + 1 ===
                                      _vm.afterUpdate.clientTypes.length
                                      ? ""
                                      : "，"
                                  )
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "限制参数" } },
                      _vm._l(
                        _vm.afterUpdate.limitParams,
                        function (item, index) {
                          return _c("span", { key: item }, [
                            _vm._v(
                              _vm._s(item) +
                                _vm._s(
                                  index + 1 ===
                                    _vm.afterUpdate.limitParams.length
                                    ? ""
                                    : "，"
                                )
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                    _c("el-form-item", { attrs: { label: "类型状态" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.afterUpdate.state) +
                          "\n          "
                      ),
                    ]),
                    _c("el-form-item", { attrs: { label: "备注" } }, [
                      _vm.afterUpdate.remark
                        ? _c("span", [_vm._v(_vm._s(_vm.afterUpdate.remark))])
                        : _c("span", [_vm._v("暂无备注")]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          !_vm.showAuditOpinion
            ? _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmitAudit },
                    },
                    [_vm._v("确认提交审核")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showAuditOpinion
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "dialog-footer" },
                  [
                    _c("el-button", { on: { click: _vm.handleReject } }, [
                      _vm._v("审核不通过"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handlePass },
                      },
                      [_vm._v("审核通过")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialog-footer" },
                  [
                    _c("el-input", {
                      staticStyle: { width: "60%" },
                      attrs: {
                        type: "textarea",
                        "show-word-limit": "",
                        autosize: { minRows: 2, maxRows: 10 },
                        maxlength: "999",
                        placeholder: "审核意见",
                      },
                      model: {
                        value: _vm.auditOpinion,
                        callback: function ($$v) {
                          _vm.auditOpinion = $$v
                        },
                        expression: "auditOpinion",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }